export default __webpack_public_path__ + "static/media/Icon_call_cancel.2f0e0300.svg";